import { Type } from '@sinclair/typebox';
export const DEFAULT_ZOOM_LEVEL_SHORTCUT_DELTA = 0.45;
export const DEFAULT_DISTANCE_IN_PIXELS = 10;
export const HASH_PARAM = {
    DISTANCE_IN_METERS: 'idist',
};
export const LAYER_IDS = {
    HIGHLIGHT: 'sys.layer.highlight',
    INFO: 'sys.layer.info',
    INFO_RESULTS: 'sys.layer.info-results',
    MEASURE: 'sys.layer.measure',
    NOTES: 'sys.layer.notes',
    NOTES_MODIFY: 'sys.layer.notes-modify',
    SEARCH: 'sys.layer.search',
    USER_LOCATION: 'sys.layer.user-location',
    EDIT_TOOLS_HIGHLIGHT: 'sys.layer.edit-tools-highlight',
    EDIT_TOOLS_MODIFY: 'sys.layer.edit-tools-modify',
    EDIT_TOOLS_SNAP: 'sys.layer.edit-tools-snap',
    PANORAMA: 'sys.layer.panorama',
};
export const LAYER_TYPE = {
    TILE: 'Tile',
    VECTOR: 'Vector',
    WMTS: 'WMTS',
    TILE_ARCGIS_REST: 'TileArcGISRest',
    TILE_ARCGIS: 'TileArcGIS',
    IMAGE_ARCGIS_REST: 'ImageArcGISRest',
    IMAGE_WMS: 'ImageWMS',
    TILE_VECTOR: 'VectorTile',
    FEATURE_ARCGIS: 'FeatureArcGIS',
};
export var INTERACTION;
(function (INTERACTION) {
    INTERACTION["NONE"] = "NONE";
    INTERACTION["DRAW"] = "DRAW";
    INTERACTION["SELECT"] = "SELECT";
    INTERACTION["MODIFY"] = "MODIFY";
    INTERACTION["SELECT_MODIFY"] = "SELECT_MODIFY";
})(INTERACTION || (INTERACTION = {}));
export var INTERACTION_KIND;
(function (INTERACTION_KIND) {
    INTERACTION_KIND["NONE"] = "NONE";
    INTERACTION_KIND["DRAW_START"] = "DRAW_START";
    INTERACTION_KIND["DRAW_END"] = "DRAW_END";
    INTERACTION_KIND["MODIFY_END"] = "MODIFY_END";
})(INTERACTION_KIND || (INTERACTION_KIND = {}));
export var OPERATION_METHOD;
(function (OPERATION_METHOD) {
    OPERATION_METHOD["UPDATE"] = "UPDATE";
    OPERATION_METHOD["DELETE"] = "DELETE";
})(OPERATION_METHOD || (OPERATION_METHOD = {}));
export const GEOMETRY_TYPE = {
    POINT: 'Point',
    LINE_STRING: 'LineString',
    POLYGON: 'Polygon',
    CIRCLE: 'Circle',
    TEXT: 'Text',
    MULTI_POINT: 'MultiPoint',
    MULTI_LINE_STRING: 'MultiLineString',
    MULTI_POLYGON: 'MultiPolygon',
    BOX: 'Box',
};
export const geometryTypeSchema = Type.Union(Object.values(GEOMETRY_TYPE).map((value) => Type.Literal(value)));
export const GEOMETRY_LAYOUT = {
    XY: 'XY',
    XYZ: 'XYZ',
    XYM: 'XYM',
    XYZM: 'XYZM',
};
export const geometryLayoutSchema = Type.Union(Object.values(GEOMETRY_LAYOUT).map((value) => Type.Literal(value)));
export var WKTGeometryType;
(function (WKTGeometryType) {
    WKTGeometryType["POINT"] = "POINT";
    WKTGeometryType["LINESTRING"] = "LINESTRING";
    WKTGeometryType["POLYGON"] = "POLYGON";
    WKTGeometryType["MULTIPOINT"] = "MULTIPOINT";
    WKTGeometryType["MULTILINESTRING"] = "MULTILINESTRING";
    WKTGeometryType["MULTIPOLYGON"] = "MULTIPOLYGON";
    WKTGeometryType["POINT_Z"] = "POINT_Z";
    WKTGeometryType["LINESTRING_Z"] = "LINESTRING_Z";
    WKTGeometryType["POLYGON_Z"] = "POLYGON_Z";
    WKTGeometryType["MULTIPOINT_Z"] = "MULTIPOINT_Z";
    WKTGeometryType["MULTILINESTRING_Z"] = "MULTILINESTRING_Z";
    WKTGeometryType["MULTIPOLYGON_Z"] = "MULTIPOLYGON_Z";
    WKTGeometryType["POINT_M"] = "POINT_M";
    WKTGeometryType["LINESTRING_M"] = "LINESTRING_M";
    WKTGeometryType["POLYGON_M"] = "POLYGON_M";
    WKTGeometryType["MULTIPOINT_M"] = "MULTIPOINT_M";
    WKTGeometryType["MULTILINESTRING_M"] = "MULTILINESTRING_M";
    WKTGeometryType["MULTIPOLYGON_M"] = "MULTIPOLYGON_M";
    WKTGeometryType["POINT_ZM"] = "POINT_ZM";
    WKTGeometryType["LINESTRING_ZM"] = "LINESTRING_ZM";
    WKTGeometryType["POLYGON_ZM"] = "POLYGON_ZM";
    WKTGeometryType["MULTIPOINT_ZM"] = "MULTIPOINT_ZM";
    WKTGeometryType["MULTILINESTRING_ZM"] = "MULTILINESTRING_ZM";
    WKTGeometryType["MULTIPOLYGON_ZM"] = "MULTIPOLYGON_ZM";
})(WKTGeometryType || (WKTGeometryType = {}));
export var PANEL;
(function (PANEL) {
    PANEL["NONE"] = "NONE";
    PANEL["LAYER_SWITCHER"] = "LAYER_SWITCHER";
    PANEL["LEGEND"] = "LEGEND";
    PANEL["MEASURE"] = "MEASURE";
    PANEL["SEARCH"] = "SEARCH";
    PANEL["NOTES"] = "NOTES";
})(PANEL || (PANEL = {}));
export var MAP_TOOL;
(function (MAP_TOOL) {
    MAP_TOOL["NONE"] = "NONE";
    MAP_TOOL["INFOEDIT"] = "INFOEDIT";
    MAP_TOOL["INTERSECTION_SPLIT_LINE"] = "INTERSECTION_SPLIT_LINE";
    MAP_TOOL["DELETE"] = "DELETE";
    MAP_TOOL["DRAW"] = "DRAW";
    MAP_TOOL["JOIN_LINE"] = "JOIN_LINE";
    MAP_TOOL["SPLIT_LINE"] = "SPLIT_LINE";
    MAP_TOOL["REVERSE_LINE"] = "REVERSE_LINE";
    MAP_TOOL["MEASURE_LINE"] = "MEASURE_LINE";
    MAP_TOOL["MEASURE_POLYGON"] = "MEASURE_POLYGON";
    MAP_TOOL["NOTE_SELECT"] = "NOTE_SELECT";
    MAP_TOOL["NOTE_DRAW_POINT"] = "NOTE_DRAW_POINT";
    MAP_TOOL["NOTE_DRAW_LINE"] = "NOTE_DRAW_LINE";
    MAP_TOOL["NOTE_DRAW_POLYGON"] = "NOTE_DRAW_POLYGON";
    MAP_TOOL["NOTE_DRAW_TEXT"] = "NOTE_DRAW_TEXT";
    MAP_TOOL["SELECT_FEATURE"] = "SELECT_FEATURE";
})(MAP_TOOL || (MAP_TOOL = {}));
export const NOTE_TOOLS = [
    MAP_TOOL.NOTE_SELECT,
    MAP_TOOL.NOTE_DRAW_LINE,
    MAP_TOOL.NOTE_DRAW_POINT,
    MAP_TOOL.NOTE_DRAW_POLYGON,
    MAP_TOOL.NOTE_DRAW_TEXT,
];
export const MEASURE_TOOLS = [MAP_TOOL.MEASURE_POLYGON, MAP_TOOL.MEASURE_LINE];
export const EDIT_TOOLS = [
    MAP_TOOL.INTERSECTION_SPLIT_LINE,
    MAP_TOOL.DELETE,
    MAP_TOOL.DRAW,
    MAP_TOOL.INFOEDIT,
    MAP_TOOL.JOIN_LINE,
    MAP_TOOL.SPLIT_LINE,
    MAP_TOOL.REVERSE_LINE,
    MAP_TOOL.SELECT_FEATURE,
];
export const geometryTypeAndLayoutByWKT = {
    POINT: { geometryType: GEOMETRY_TYPE.POINT, geometryLayout: GEOMETRY_LAYOUT.XY },
    LINESTRING: { geometryType: GEOMETRY_TYPE.LINE_STRING, geometryLayout: GEOMETRY_LAYOUT.XY },
    POLYGON: { geometryType: GEOMETRY_TYPE.POLYGON, geometryLayout: GEOMETRY_LAYOUT.XY },
    MULTIPOINT: { geometryType: GEOMETRY_TYPE.MULTI_POINT, geometryLayout: GEOMETRY_LAYOUT.XY },
    MULTILINESTRING: {
        geometryType: GEOMETRY_TYPE.MULTI_LINE_STRING,
        geometryLayout: GEOMETRY_LAYOUT.XY,
    },
    MULTIPOLYGON: { geometryType: GEOMETRY_TYPE.MULTI_POLYGON, geometryLayout: GEOMETRY_LAYOUT.XY },
    POINT_Z: { geometryType: GEOMETRY_TYPE.POINT, geometryLayout: GEOMETRY_LAYOUT.XYZ },
    LINESTRING_Z: { geometryType: GEOMETRY_TYPE.LINE_STRING, geometryLayout: GEOMETRY_LAYOUT.XYZ },
    POLYGON_Z: { geometryType: GEOMETRY_TYPE.POLYGON, geometryLayout: GEOMETRY_LAYOUT.XYZ },
    MULTIPOINT_Z: { geometryType: GEOMETRY_TYPE.MULTI_POINT, geometryLayout: GEOMETRY_LAYOUT.XYZ },
    MULTILINESTRING_Z: {
        geometryType: GEOMETRY_TYPE.MULTI_LINE_STRING,
        geometryLayout: GEOMETRY_LAYOUT.XYZ,
    },
    MULTIPOLYGON_Z: {
        geometryType: GEOMETRY_TYPE.MULTI_POLYGON,
        geometryLayout: GEOMETRY_LAYOUT.XYZ,
    },
    POINT_M: { geometryType: GEOMETRY_TYPE.POINT, geometryLayout: GEOMETRY_LAYOUT.XYM },
    LINESTRING_M: { geometryType: GEOMETRY_TYPE.LINE_STRING, geometryLayout: GEOMETRY_LAYOUT.XYM },
    POLYGON_M: { geometryType: GEOMETRY_TYPE.POLYGON, geometryLayout: GEOMETRY_LAYOUT.XYM },
    MULTIPOINT_M: { geometryType: GEOMETRY_TYPE.MULTI_POINT, geometryLayout: GEOMETRY_LAYOUT.XYM },
    MULTILINESTRING_M: {
        geometryType: GEOMETRY_TYPE.MULTI_LINE_STRING,
        geometryLayout: GEOMETRY_LAYOUT.XYM,
    },
    MULTIPOLYGON_M: {
        geometryType: GEOMETRY_TYPE.MULTI_POLYGON,
        geometryLayout: GEOMETRY_LAYOUT.XYM,
    },
    POINT_ZM: { geometryType: GEOMETRY_TYPE.POINT, geometryLayout: GEOMETRY_LAYOUT.XYZM },
    LINESTRING_ZM: { geometryType: GEOMETRY_TYPE.LINE_STRING, geometryLayout: GEOMETRY_LAYOUT.XYZM },
    POLYGON_ZM: { geometryType: GEOMETRY_TYPE.POLYGON, geometryLayout: GEOMETRY_LAYOUT.XYZM },
    MULTIPOINT_ZM: { geometryType: GEOMETRY_TYPE.MULTI_POINT, geometryLayout: GEOMETRY_LAYOUT.XYZM },
    MULTILINESTRING_ZM: {
        geometryType: GEOMETRY_TYPE.MULTI_LINE_STRING,
        geometryLayout: GEOMETRY_LAYOUT.XYZM,
    },
    MULTIPOLYGON_ZM: {
        geometryType: GEOMETRY_TYPE.MULTI_POLYGON,
        geometryLayout: GEOMETRY_LAYOUT.XYZM,
    },
};
//# sourceMappingURL=constants.js.map